export default {
  hot_news: "hot news".toUpperCase(),
};
